import {z} from 'zod'

import {exerciseTypes} from '#/themes/classic-quiz/exerciseTypes'
import {type ThemePlugin} from '#/types/capsule'
import {PixelArtEditor} from './PixelArtEditor'
import {PixelArtPlayer} from './PixelArtPlayer'

const pixelArtTheme: ThemePlugin = {
  id: 'pixel-art',
  name: 'Sprout Quest',
  version: '2.0.0',
  description: 'Cozy pixel-art RPG — parchment panels, hearts, coins & quests',
  previewColor: '#22c55e',
  category: 'games',
  exerciseTypes,
  settingsSchema: z.object({
    instantFeedback: z.boolean().default(true),
    showProgressBar: z.boolean().default(true),
    shuffleOptions: z.boolean().default(false),
  }),
  PlayerComponent: PixelArtPlayer,
  EditorComponent: PixelArtEditor,
  PreviewComponent: PixelArtPlayer,
}

export default pixelArtTheme
